import React, { useContext } from 'react'
import TruncateMarkup from 'react-truncate-markup'

import { LanguageContext } from '../../../context/LanguageContext'
import { ToolTip } from '..'
import { util } from '../../../util'

const TruncateToolTip = ({ list, lines, toolTipPlacement, transform, viewAllInTooltip }) => {
    // Contexts
    const { strings } = useContext(LanguageContext)

    if (!list.length) {
        return null
    }

    const renderEllipsis = node => {
        let toolTipList
        if (!!viewAllInTooltip) {
            toolTipList = list
        } else {
            const regionsRendered = node.props.children
            toolTipList = list.slice(regionsRendered.length)
        }
        const renderToolTip = () => (
            <div className={'card__flex'}>
                <span>
                    {!!transform ? transform(toolTipList) : util.getStringsFromArray(toolTipList)}
                </span>
            </div>
        )
        return (
            <ToolTip
                className={'ml-1'}
                display={'inline-block'}
                highlight
                placement={toolTipPlacement}
                render={renderToolTip}
            >
                {!!viewAllInTooltip ? strings.VIEW_ALL : `${toolTipList.length}+ more`}
            </ToolTip>
        )
    }

    return (
        <div className={'table-row__cell--tool-tip-wrapper'} data-testid={'truncate_tooltip'}>
            <TruncateMarkup lines={lines} ellipsis={renderEllipsis}>
                <div
                    style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}
                    className={'card__regions'}
                >
                    {list.map((state, i) => {
                        return (
                            <TruncateMarkup.Atom key={i}>
                                <span
                                    className={util.joinClasses(
                                        i + 1 === list.length ? 'config-end' : 'config-comma'
                                    )}
                                    key={i}
                                >
                                    {state}
                                </span>
                            </TruncateMarkup.Atom>
                        )
                    })}
                </div>
            </TruncateMarkup>
        </div>
    )
}

export default TruncateToolTip
